module.exports = function() {
  return new Worker(__webpack_public_path__ + "fe4e6a84432c67de5615.worker.js");
};